import ReactOtpInput from "react-otp-input";

interface OtpInputProps {
    numInputs: number;
    value: string;
    onChange: (value: string) => void;
    isError?: boolean;
    containerStyle?: React.CSSProperties;
    inputStyle?: React.CSSProperties;
    shouldAutoFocus?: boolean;
}

export const OtpInput = ({
    numInputs,
    value,
    onChange,
    isError,
    shouldAutoFocus = true,
}: OtpInputProps) => {
    return (
        <ReactOtpInput
            numInputs={numInputs}
            renderInput={(props) => (
                <input
                    {...props}
                    type="number"
                    className={`otp-input ${isError ? "invalid" : ""}`}
                />
            )}
            value={value}
            onChange={onChange}
            containerStyle={{
                display: "flex",
                flexDirection: "row-reverse",
                justifyContent: "space-between",
                gap: "8px",
                width: "100%",
            }}
            inputStyle={{
                minWidth: "30px",
                width: "100%",
                padding: "0px",
            }}
            shouldAutoFocus={shouldAutoFocus}
        />
    );
};
